import { computed } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-376f7598"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "table-content"
};
const _hoisted_2 = {
  class: "btn-content flex-end"
};
const _hoisted_3 = {
  class: "btn-content"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "已自动过滤出可删除商品", -1));
const _hoisted_5 = {
  key: 0,
  class: "status-content"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "同步状态", -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "用于判断商品信息是否已成功上传到第三方后台", -1));
const _hoisted_8 = {
  key: 1,
  class: "status-content"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "商品状态", -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "用于判断该商品是否处于可用状态", -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "有效：可随版本发布", -1));
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "失效：该商品已停用", -1));
const _hoisted_13 = {
  key: 0
};
const _hoisted_14 = {
  key: 0,
  class: "channel-price-cell"
};
const _hoisted_15 = {
  class: "channel-price-row price-content"
};
const _hoisted_16 = {
  class: "price"
};
const _hoisted_17 = {
  class: "country"
};
const _hoisted_18 = {
  class: "country-price"
};
const _hoisted_19 = {
  key: 1,
  class: "price-content"
};
const _hoisted_20 = {
  class: "price"
};
const _hoisted_21 = {
  class: "country"
};
const _hoisted_22 = {
  class: "country-price"
};
const _hoisted_23 = {
  class: "elli-multiple-2"
};
const _hoisted_24 = {
  key: 3,
  class: "prod-id-content"
};
const _hoisted_25 = {
  class: "elli-multiple-2"
};
const _hoisted_26 = {
  class: "country"
};
const _hoisted_27 = {
  key: 1,
  class: "status-content"
};
const _hoisted_28 = {
  key: 5,
  class: "status-content"
};
const _hoisted_29 = {
  key: 1,
  class: "status-content"
};
const _hoisted_30 = {
  key: 9,
  class: "handle-content"
};
const _hoisted_31 = {
  style: {
    "max-height": "360px",
    "overflow-y": "auto"
  }
};
const _hoisted_32 = {
  style: {
    "margin-top": "12px"
  }
};
import { useJudgeTable, publishStatusList, approvalStatusList, prodStatusList, statusColorList, optTypeList, prodTypeList, columns } from '../hooks/useJudgeTable';
import RejectModal from '@/views/goodsManage/goodsJudge/components/RejectModal.vue';
import { LoadingOutlined } from '@ant-design/icons-vue';
import ChannelStatusCell from '@/components/channelStatus/ChannelStatusCell.vue';
import { getChannelStatusRows, getThirdPartyPriceRows, getDefaultChannel, isMultiChannel } from '@/components/channelStatus/channelStatus';
export default /*#__PURE__*/_defineComponent({
  __name: 'JudgeTableBlock',
  props: {
    tableLoading: Boolean
  },
  emits: ['goDetail', 'update:tableLoading', 'updateStatistics'],
  setup(__props, {
    expose,
    emit: emits
  }) {
    const props = __props;
    const progressMap = new Map([['begin', '开始'], ['progress', '执行中'], ['success', '执行成功'], ['warn', '执行异常'], ['error', '执行失败'], ['complete', '执行结束']]);
    const areaCodeMap = {
      CHN: '中国'
    };
    const {
      userInfo,
      dataSource,
      selectedRowKeys,
      pageIndex,
      pageSize,
      pageTotal,
      tableRef,
      tableHeight,
      editItem,
      loading,
      passLoading,
      rejectVisible,
      isEditModal,
      appName,
      exportLoading,
      isProdStatus,
      pendingReviewNum,
      toBeRejectNum,
      toBeReleasedNum,
      searchObj,
      sseMessageModal,
      syncProductSSEMessage,
      sseMessageLoading,
      isShowDelButton,
      canDelList,
      canRejectProduct,
      getData,
      searchData,
      changePage,
      openDetail,
      batchPass,
      batchReject,
      onSelectChange,
      batchPublishProduct,
      openRejectModal,
      productPass,
      submitReject,
      exportGoodsExcel,
      setProductName,
      deleteChinaSaleArea,
      handleSSEMessageModalOk,
      handlerDelModal
    } = useJudgeTable(emits);
    const delBtnText = computed(() => {
      return canDelList.value.length ? `删除商品(${canDelList.value.length})` : '删除商品';
    });
    // 苹果渠道的同步状态 / 商品状态按渠道分行展示
    const isMultiChnl = computed(() => isMultiChannel(searchObj.value.prodChnl));
    const defaultChannel = computed(() => getDefaultChannel(searchObj.value.prodChnl));
    expose({
      searchData,
      setProductName,
      appName,
      getData
    });
    return (_ctx, _cache) => {
      var _unref6;
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      const _component_a_space = _resolveComponent("a-space");
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_a_popover = _resolveComponent("a-popover");
      const _component_a_table = _resolveComponent("a-table");
      const _component_a_pagination = _resolveComponent("a-pagination");
      const _component_a_modal = _resolveComponent("a-modal");
      const _directive_permission = _resolveDirective("permission");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_a_space, null, {
        default: _withCtx(() => {
          var _unref2, _unref3, _unref4;
          return [_unref(isProdStatus) ? _withDirectives((_openBlock(), _createBlock(_component_a_button, {
            key: 0,
            disabled: !_unref(pendingReviewNum),
            onClick: _unref(batchPass),
            loading: _unref(passLoading)
          }, {
            default: _withCtx(() => [_createTextVNode(" 批量通过" + _toDisplayString(_unref(pendingReviewNum) ? `(${_unref(pendingReviewNum)})` : ''), 1)]),
            _: 1
          }, 8, ["disabled", "onClick", "loading"])), [[_directive_permission, {
            permissionValue: 'goodsJudge',
            permissionArr: (_unref2 = _unref(userInfo)) === null || _unref2 === void 0 ? void 0 : _unref2.permissions
          }]]) : _createCommentVNode("", true), _unref(isProdStatus) ? _withDirectives((_openBlock(), _createBlock(_component_a_button, {
            key: 1,
            disabled: !_unref(toBeRejectNum),
            onClick: _unref(batchReject),
            loading: _unref(passLoading)
          }, {
            default: _withCtx(() => [_createTextVNode(" 批量驳回" + _toDisplayString(_unref(toBeRejectNum) ? `(${_unref(toBeRejectNum)})` : ''), 1)]),
            _: 1
          }, 8, ["disabled", "onClick", "loading"])), [[_directive_permission, {
            permissionValue: 'goodsJudge',
            permissionArr: (_unref3 = _unref(userInfo)) === null || _unref3 === void 0 ? void 0 : _unref3.permissions
          }]]) : _createCommentVNode("", true), _unref(isProdStatus) ? _withDirectives((_openBlock(), _createBlock(_component_a_button, {
            key: 2,
            disabled: !_unref(toBeReleasedNum),
            loading: _unref(loading),
            type: "primary",
            onClick: _cache[0] || (_cache[0] = $event => _unref(batchPublishProduct)())
          }, {
            default: _withCtx(() => [_createTextVNode(" 同步商品" + _toDisplayString(_unref(toBeReleasedNum) ? `(${_unref(toBeReleasedNum)})` : ''), 1)]),
            _: 1
          }, 8, ["disabled", "loading"])), [[_directive_permission, {
            permissionValue: 'goodsJudge',
            permissionArr: (_unref4 = _unref(userInfo)) === null || _unref4 === void 0 ? void 0 : _unref4.permissions
          }]]) : _createCommentVNode("", true), !_unref(isProdStatus) && _unref(searchObj).prodChnl === 'apple' ? (_openBlock(), _createBlock(_component_a_button, {
            key: 3,
            onClick: _unref(deleteChinaSaleArea)
          }, {
            default: _withCtx(() => [_createTextVNode(" 删除中国销售地区 ")]),
            _: 1
          }, 8, ["onClick"])) : _createCommentVNode("", true), _createVNode(_component_a_tooltip, null, {
            title: _withCtx(() => [_hoisted_4]),
            default: _withCtx(() => [_unref(isShowDelButton) && _unref(searchObj).prodChnl === 'apple' ? (_openBlock(), _createBlock(_component_a_button, {
              key: 0,
              disabled: !_unref(canDelList).length,
              onClick: _unref(handlerDelModal)
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(delBtnText)), 1)]),
              _: 1
            }, 8, ["disabled", "onClick"])) : _createCommentVNode("", true)]),
            _: 1
          })];
        }),
        _: 1
      })]), !_unref(isProdStatus) ? (_openBlock(), _createBlock(_component_a_button, {
        key: 0,
        onClick: _unref(exportGoodsExcel),
        loading: _unref(exportLoading)
      }, {
        icon: _withCtx(() => [_createVNode(_component_svg_icon, {
          "icon-class": "export",
          "class-name": "export-icon"
        })]),
        default: _withCtx(() => [_createTextVNode(" 导出 ")]),
        _: 1
      }, 8, ["onClick", "loading"])) : _createCommentVNode("", true)]), _createVNode(_component_a_table, {
        bordered: "",
        columns: _unref(columns),
        "data-source": _unref(dataSource),
        "row-key": "id",
        pagination: false,
        ref_key: "tableRef",
        ref: tableRef,
        scroll: {
          y: _unref(tableHeight),
          x: 2280
        },
        "row-selection": {
          selectedRowKeys: _unref(selectedRowKeys),
          onChange: _unref(onSelectChange),
          preserveSelectedRowKeys: true
        },
        loading: props.tableLoading
      }, {
        headerCell: _withCtx(({
          column
        }) => [column.key === 'publishStatus' ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_hoisted_6, _createVNode(_component_a_tooltip, {
          placement: "topLeft"
        }, {
          title: _withCtx(() => [_hoisted_7]),
          default: _withCtx(() => [_createVNode(_component_svg_icon, {
            "icon-class": "questionMark",
            "class-name": "prompt-icon"
          })]),
          _: 1
        })])) : _createCommentVNode("", true), column.key === 'prodStatus' ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_hoisted_9, _createVNode(_component_a_tooltip, {
          placement: "topLeft"
        }, {
          title: _withCtx(() => [_hoisted_10, _hoisted_11, _hoisted_12]),
          default: _withCtx(() => [_createVNode(_component_svg_icon, {
            "icon-class": "questionMark",
            "class-name": "prompt-icon"
          })]),
          _: 1
        })])) : _createCommentVNode("", true)]),
        bodyCell: _withCtx(({
          column,
          record,
          index
        }) => {
          var _record$bizInfo, _unref5;
          return [column.dataIndex === 'index' ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString((_unref(pageIndex) - 1) * _unref(pageSize) + index + 1), 1)) : _createCommentVNode("", true), column.dataIndex === 'price' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_unref(isMultiChnl) ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createVNode(_component_a_tooltip, {
            title: `${_unref(defaultChannel).tooltip.replace('状态', '')}官方价格`
          }, {
            default: _withCtx(() => [_createElementVNode("span", {
              class: _normalizeClass(["channel-tag", _unref(defaultChannel).key])
            }, _toDisplayString(_unref(defaultChannel).tag), 3)]),
            _: 1
          }, 8, ["title"]), _createElementVNode("span", _hoisted_16, _toDisplayString(record.prodPriceCurrency) + " " + _toDisplayString(record.prodPrice), 1), _createVNode(_component_a_popover, {
            title: "本地价格",
            overlayClassName: "price-popover",
            trigger: "hover",
            placement: "rightTop"
          }, {
            content: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.changePriceList, item => {
              return _openBlock(), _createElementBlock("div", {
                class: "price-list",
                key: item.regionName
              }, [_createElementVNode("div", _hoisted_17, _toDisplayString(item['regionName']), 1), _createElementVNode("div", _hoisted_18, _toDisplayString(item['prodPrice']), 1)]);
            }), 128))]),
            default: _withCtx(() => {
              var _record$changePriceLi;
              return [record !== null && record !== void 0 && (_record$changePriceLi = record.changePriceList) !== null && _record$changePriceLi !== void 0 && _record$changePriceLi.length ? (_openBlock(), _createBlock(_component_svg_icon, {
                key: 0,
                "icon-class": "prompt2",
                "class-name": "prompt-icon"
              })) : _createCommentVNode("", true)];
            }),
            _: 2
          }, 1024)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getThirdPartyPriceRows)(record, _unref(searchObj).prodChnl), row => {
            return _openBlock(), _createElementBlock("div", {
              key: row.key,
              class: "channel-price-row"
            }, [_createVNode(_component_a_tooltip, {
              title: row.tooltip
            }, {
              default: _withCtx(() => [_createElementVNode("span", {
                class: _normalizeClass(["channel-tag", row.key])
              }, _toDisplayString(row.tag), 3)]),
              _: 2
            }, 1032, ["title"]), _createElementVNode("span", null, _toDisplayString(row.currency) + " " + _toDisplayString(row.price), 1)]);
          }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_19, [_createElementVNode("span", _hoisted_20, _toDisplayString(record.prodPriceCurrency) + " " + _toDisplayString(record.prodPrice), 1), _createVNode(_component_a_popover, {
            title: "本地价格",
            overlayClassName: "price-popover",
            trigger: "hover",
            placement: "rightTop"
          }, {
            content: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.changePriceList, item => {
              return _openBlock(), _createElementBlock("div", {
                class: "price-list",
                key: item.regionName
              }, [_createElementVNode("div", _hoisted_21, _toDisplayString(item['regionName']), 1), _createElementVNode("div", _hoisted_22, _toDisplayString(item['prodPrice']), 1)]);
            }), 128))]),
            default: _withCtx(() => {
              var _record$changePriceLi2;
              return [record !== null && record !== void 0 && (_record$changePriceLi2 = record.changePriceList) !== null && _record$changePriceLi2 !== void 0 && _record$changePriceLi2.length ? (_openBlock(), _createBlock(_component_svg_icon, {
                key: 0,
                "icon-class": "prompt2",
                "class-name": "prompt-icon"
              })) : _createCommentVNode("", true)];
            }),
            _: 2
          }, 1024)]))], 64)) : _createCommentVNode("", true), column.dataIndex === 'name' ? (_openBlock(), _createBlock(_component_a_tooltip, {
            key: 2,
            placement: "topLeft"
          }, {
            title: _withCtx(() => [_createTextVNode(_toDisplayString(record.prodName), 1)]),
            default: _withCtx(() => [_createElementVNode("div", _hoisted_23, _toDisplayString(record.prodName), 1)]),
            _: 2
          }, 1024)) : _createCommentVNode("", true), column.dataIndex === 'prodId' ? (_openBlock(), _createElementBlock("div", _hoisted_24, [_createVNode(_component_a_tooltip, {
            placement: "topLeft"
          }, {
            title: _withCtx(() => [_createTextVNode(_toDisplayString(record.prodId), 1)]),
            default: _withCtx(() => [_createElementVNode("div", _hoisted_25, _toDisplayString(record.prodId), 1)]),
            _: 2
          }, 1024), (_record$bizInfo = record.bizInfo) !== null && _record$bizInfo !== void 0 && (_record$bizInfo = _record$bizInfo.removedAreaCodes) !== null && _record$bizInfo !== void 0 && _record$bizInfo.length ? (_openBlock(), _createBlock(_component_a_popover, {
            key: 0,
            title: "已删除销售地区",
            overlayClassName: "price-popover",
            trigger: "hover",
            placement: "rightTop"
          }, {
            content: _withCtx(() => {
              var _record$bizInfo2;
              return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_record$bizInfo2 = record.bizInfo) === null || _record$bizInfo2 === void 0 ? void 0 : _record$bizInfo2.removedAreaCodes, code => {
                return _openBlock(), _createElementBlock("div", {
                  class: "price-list",
                  key: code
                }, [_createElementVNode("div", _hoisted_26, _toDisplayString(areaCodeMap[code] || code), 1)]);
              }), 128))];
            }),
            default: _withCtx(() => [_createVNode(_component_svg_icon, {
              "icon-class": "prompt2",
              "class-name": "prompt-icon"
            })]),
            _: 2
          }, 1024)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), column.dataIndex === 'publishStatus' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 4
          }, [_unref(isMultiChnl) ? (_openBlock(), _createBlock(ChannelStatusCell, {
            key: 0,
            rows: _unref(getChannelStatusRows)(record, 'publish', _unref(searchObj).prodChnl)
          }, null, 8, ["rows"])) : (_openBlock(), _createElementBlock("div", _hoisted_27, [record.publishStatus === 20 || record.publishStatus === 5 ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 0,
            "icon-class": "send_fail",
            "class-name": "red-icon"
          })) : _createCommentVNode("", true), record.publishStatus === 10 ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 1,
            "icon-class": "success",
            "class-name": "red-icon"
          })) : _createCommentVNode("", true), record.publishStatus === 4 ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 2,
            "icon-class": "outline",
            "class-name": "red-icon"
          })) : _createCommentVNode("", true), _createElementVNode("span", null, _toDisplayString(_unref(publishStatusList)[record.publishStatus]), 1)]))], 64)) : _createCommentVNode("", true), column.dataIndex === 'approvalStatus' ? (_openBlock(), _createElementBlock("div", _hoisted_28, [_createElementVNode("span", {
            class: _normalizeClass(["circle", _unref(statusColorList)[record.approvalStatus]])
          }, null, 2), record.approvalStatus !== 20 ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: _normalizeClass(record.approvalStatus === 20 ? 'blue' : '')
          }, _toDisplayString(_unref(approvalStatusList)[record.approvalStatus]), 3)) : (_openBlock(), _createBlock(_component_a_tooltip, {
            key: 1,
            placement: "right"
          }, {
            title: _withCtx(() => [_createElementVNode("div", null, _toDisplayString(record.rejectMsg), 1)]),
            default: _withCtx(() => [_createElementVNode("span", {
              class: _normalizeClass(record.approvalStatus === 20 ? 'blue' : '')
            }, _toDisplayString(_unref(approvalStatusList)[record.approvalStatus]), 3)]),
            _: 2
          }, 1024))])) : _createCommentVNode("", true), column.dataIndex === 'prodStatus' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 6
          }, [_unref(isMultiChnl) ? (_openBlock(), _createBlock(ChannelStatusCell, {
            key: 0,
            rows: _unref(getChannelStatusRows)(record, 'product', _unref(searchObj).prodChnl)
          }, null, 8, ["rows"])) : (_openBlock(), _createElementBlock("div", _hoisted_29, [record.prodStatus === 10 ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 0,
            "icon-class": "success",
            "class-name": "red-icon"
          })) : _createCommentVNode("", true), record.prodStatus === 20 ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 1,
            "icon-class": "outline",
            "class-name": "red-icon"
          })) : _createCommentVNode("", true), _createElementVNode("span", null, _toDisplayString(_unref(prodStatusList)[record.prodStatus]), 1)]))], 64)) : _createCommentVNode("", true), column.dataIndex === 'optType' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 7
          }, [_createTextVNode(_toDisplayString(_unref(optTypeList)[record.optType]), 1)], 64)) : _createCommentVNode("", true), column.dataIndex === 'prodType' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 8
          }, [_createTextVNode(_toDisplayString(_unref(prodTypeList)[record.prodType]), 1)], 64)) : _createCommentVNode("", true), column.dataIndex === 'handle' ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_30, [_unref(isProdStatus) ? (_openBlock(), _createBlock(_component_a_button, {
            key: 0,
            type: "link",
            onClick: $event => _unref(openRejectModal)(record),
            disabled: !_unref(canRejectProduct)(record)
          }, {
            default: _withCtx(() => [_createTextVNode(" 驳回 ")]),
            _: 2
          }, 1032, ["onClick", "disabled"])) : _createCommentVNode("", true), _unref(isProdStatus) ? (_openBlock(), _createBlock(_component_a_button, {
            key: 1,
            type: "link",
            onClick: $event => _unref(productPass)(record),
            disabled: record.approvalStatus === 20 || record.approvalStatus === 30
          }, {
            default: _withCtx(() => [_createTextVNode(" 通过 ")]),
            _: 2
          }, 1032, ["onClick", "disabled"])) : _createCommentVNode("", true), _createVNode(_component_a_button, {
            type: "link",
            onClick: $event => _unref(openDetail)(record)
          }, {
            default: _withCtx(() => [_createTextVNode("详情")]),
            _: 2
          }, 1032, ["onClick"])])), [[_directive_permission, {
            permissionValue: 'goodsJudge',
            permissionArr: (_unref5 = _unref(userInfo)) === null || _unref5 === void 0 ? void 0 : _unref5.permissions
          }]]) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["columns", "data-source", "scroll", "row-selection", "loading"]), _createVNode(_component_a_pagination, {
        current: _unref(pageIndex),
        "page-size": _unref(pageSize),
        total: _unref(pageTotal),
        "show-size-changer": "",
        "show-total": total => `共 ${total} 条`,
        onChange: _unref(changePage)
      }, null, 8, ["current", "page-size", "total", "show-total", "onChange"]), _createVNode(RejectModal, {
        "modal-visible": _unref(rejectVisible),
        "onUpdate:modal-visible": _cache[1] || (_cache[1] = $event => _isRef(rejectVisible) ? rejectVisible.value = $event : null),
        "reject-msg": (_unref6 = _unref(editItem)) === null || _unref6 === void 0 ? void 0 : _unref6.rejectMsg,
        "is-edit": _unref(isEditModal),
        onSubmitReject: _unref(submitReject)
      }, null, 8, ["modal-visible", "reject-msg", "is-edit", "onSubmitReject"]), _createVNode(_component_a_modal, {
        open: _unref(sseMessageModal),
        "onUpdate:open": _cache[2] || (_cache[2] = $event => _isRef(sseMessageModal) ? sseMessageModal.value = $event : null),
        title: "同步状态",
        onOk: _unref(handleSSEMessageModalOk),
        style: {
          "width": "500px"
        }
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_31, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(syncProductSSEMessage), (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: index
          }, _toDisplayString(_unref(progressMap).get(item) ? _unref(progressMap).get(item) : item), 1);
        }), 128))]), _createElementVNode("div", _hoisted_32, [_createTextVNode(_toDisplayString(_unref(sseMessageLoading) ? '同步中...' : '同步完成') + " ", 1), _unref(sseMessageLoading) ? (_openBlock(), _createBlock(_unref(LoadingOutlined), {
          key: 0
        })) : _createCommentVNode("", true)])]),
        _: 1
      }, 8, ["open", "onOk"])]);
    };
  }
});